module.exports = __webpack_public_path__ + "static/Kenku-6aec394774c9eb7a9a98ccce021b680f.jpg";